import { render, staticRenderFns } from "./hotelRoom.vue?vue&type=template&id=e22f2ad2&scoped=true"
import script from "./hotelRoom.vue?vue&type=script&lang=js"
export * from "./hotelRoom.vue?vue&type=script&lang=js"
import style0 from "./hotelRoom.vue?vue&type=style&index=0&id=e22f2ad2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22f2ad2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e22f2ad2')) {
      api.createRecord('e22f2ad2', component.options)
    } else {
      api.reload('e22f2ad2', component.options)
    }
    module.hot.accept("./hotelRoom.vue?vue&type=template&id=e22f2ad2&scoped=true", function () {
      api.rerender('e22f2ad2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/reunionDinnerManagement/dishRoomsManagement/hotelRoom.vue"
export default component.exports